import React from "react";
import { Form, Col } from "react-bootstrap";
import { DatePicker as RSDatePicker } from "rsuite";

export default function TimePicker({
    formData,
    setFormData,
    name,
    size = "md",
    readOnly = false,
    plaintext = false,
    label = "Time",
    formKey = "time",
    seconds = "00",
    onlyInput = false,
}) {
    const input = (
        <RSDatePicker
            size={size}
            readOnly={readOnly}
            plaintext={plaintext}
            value={formData[formKey]}
            onChange={value => setFormData({ ...formData, [formKey]: value })}
            format={`HH:mm:${seconds}`}
            block
        />
    );

    if (onlyInput) return input;

    return (
        <Form.Group as={Col} className={`col col-xl-1 min-w-time-picker-${size}`} controlId={`${name}-time`}>
            <Form.Label>{label}</Form.Label>
            {input}
        </Form.Group>
    );
}
